import './style.css'
import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { loadFromLocalStorage } from '../../utils/LocalStorageUtils';
import Address from './address';
function Footer() {
  const navigate = useNavigate();
  const authData = loadFromLocalStorage("AUTH_DATA");
  const [languageData, setLanguageData] = useState(null);
  const selectLang = loadFromLocalStorage("SELECTLANGUAGE");


  // useEffect(() => {
  //   setLanguageData(selectLang?.language)
  // }, [selectLang])

  // Memoize the language data
  const memoizedLanguageData = useMemo(() => selectLang?.language, [selectLang]);

  useEffect(() => {
    setLanguageData(memoizedLanguageData);
  }, [memoizedLanguageData]);

  return (
    <section className="footer-section pb-0">
      <div className="container">
        <div className="row footer-ll">
          <div className="col-lg-6 col-md-12 col-12 text-center-sm">
            <Link to='/enquires'><img
              src="/assets/images/fulllogo.png"
              alt=""
            /></Link>
            <ul>
              <li>
                <p style={{ textAlign: 'justify', marginRight: '2rem', fontSize: 15 }}>{languageData?.atMyDigitalIndiaWeAreDedicated}</p>
              </li>
            </ul>
          </div>
          <div className="col-lg-2 col-md-4 col-4">
            <h6 style={{ borderBottom: '2px solid #ff671f', color: '#ff671f', paddingBottom: '0.7rem', width: 'fit-content' }}>{languageData?.pages}</h6>
            <ul>
              <li>
                <Link to='/about' style={{ color: 'inherit' }}>
                  <a>{languageData?.aboutUs}</a>
                </Link>
              </li>
              <li>
                <Link to='/blogs' style={{ color: 'inherit' }}>
                  <a>{languageData?.blogs}</a>
                </Link>
              </li>
              <li>
                <Link to='/ourtemplate' style={{ color: 'inherit' }}>
                  <a>{languageData?.ourTemplates}</a>
                </Link>
              </li>
              <li>
                <Link to='/termsnconditions' style={{ color: 'inherit' }}>
                  <a>{languageData?.termsAndConditions}</a>
                </Link>
              </li>
              <li>
                <Link to='/privacypolicies' style={{ color: 'inherit' }}>
                  <a>{languageData?.privacyPolicy}</a>
                </Link>
              </li>
            </ul>
          </div>
          <div className="col-lg-2 col-md-4 col-4">
            <h6 style={{ borderBottom: '2px solid #ff671f', color: '#ff671f', paddingBottom: '0.7rem', width: 'fit-content' }}>{languageData?.help}</h6>
            <ul>
              <li>
                <Link to='/contactus' style={{ color: 'inherit' }}>
                  <a>{languageData?.contactUs}</a>
                </Link>
              </li>
              <li>
                <Link to='/help-center' style={{ color: 'inherit' }}>
                  <a>{languageData?.helpCenter}</a>
                </Link>
              </li>
            </ul>
          </div>
          <div className="col-lg-2 col-md-4 col-4">
            <h6 style={{ borderBottom: '2px solid #ff671f', color: '#ff671f', paddingBottom: '0.7rem', width: 'fit-content' }}>{languageData?.access}</h6>
            <ul>
              <li>
                <Link to='/login' style={{ color: 'inherit' }}>
                  <a>{languageData?.signIn}</a>
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <Address />
    </section>
  );
}

export default Footer;